import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {handlePageClick, renderPrevArrow, renderPages, renderNextArrow, renderFirstPage, renderLastPage} from '../actions/pagination';

const Pagination = ({ pagesArray, activePage, setActivePage, setParams, searchInput }) => {
	// state that triggers scrolling
	const [clickedBtnVal, setClickedBtnVal] = useState(null);
	// scrolls to top of the items grid on pagination click
	useEffect(() => {
		const topPosition = searchInput.current.offsetTop - 50;
		if (clickedBtnVal) {
			setTimeout(() => {
				window.scrollTo({ top: topPosition, left: 0, behavior: "smooth" });
			}, 500);
		}
	}, [clickedBtnVal]);

	return (
		<ul onClick={(event) => handlePageClick(event, activePage, setParams, setActivePage, setClickedBtnVal)} className='collection-pagination'>
			{ renderPrevArrow(pagesArray, activePage) }
			{ renderFirstPage(pagesArray, activePage) }
			{ renderPages(pagesArray, activePage) }
			{ renderLastPage(pagesArray, activePage) }
			{ renderNextArrow(pagesArray, activePage) }
		</ul>
	)
}

export default Pagination;

Pagination.propTypes = {
	pagesArray: PropTypes.array,
	activePage: PropTypes.number,
	setActivePage: PropTypes.func,
	setParams: PropTypes.func,
	searchInput: PropTypes.object,
}